<template>
  <div class="b2b-grid__price">
    <template v-if="saleAdvertisedPrice">
      <div class="b2b-grid__discount">
        <span class="block line-through text-secondary"
          ><s>{{ advertisedPrice }}</s></span
        >
        <span class="block text-alert">{{ saleAdvertisedPrice }}</span>
      </div>
    </template>
    <template v-else>
      <div class="b2b-grid__price--no-discount">
        <span class="block">{{ advertisedPrice }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import get from 'lodash/get';
export default {
  name: 'GridAdvertisedPrice',
  props: {
    price: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    advertisedPrice() {
      return get(this.price.advertised, 'low.formatted');
    },
    saleAdvertisedPrice() {
      return get(this.price.saleAdvertised, 'low.formatted');
    },
  },
  methods: {
    hasSalePrice() {
      return get(this.price.saleAdvertised, 'low.value');
    },
  },
};
</script>
